import { render, staticRenderFns } from "./ClaimCreate.vue?vue&type=template&id=64189041"
import script from "./ClaimCreate.vue?vue&type=script&lang=js"
export * from "./ClaimCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports